<template>
  <div
    :id="'infinite-loading-container_' + ct"
    :style="listHeight"
    class="ios-scroll-fix"
  >
    <v-list class="unique-list" v-if="hirek.length > 0">
      <template v-for="(item, i) in hirek">
        <k-hir-kereses-lista-item
          :key="item.Id"
          :source="item"
          :isElozmeny="isElozmeny"
        >
        </k-hir-kereses-lista-item>
        <v-divider
          class="primary"
          v-if="i < hirek.length - 1"
          :key="'d' + item.Id"
        ></v-divider>
      </template>
    </v-list>
    <template v-else>
      <v-list class="unique-list" v-if="showSkeleton && hirekLoading">
        <template v-for="item in 15">
          <v-skeleton-loader :key="item" type="list-item-avatar-two-line">
          </v-skeleton-loader>
          <v-divider v-if="item != 15" :key="'d' + item"></v-divider>
        </template>
      </v-list>
      <div v-else-if="showSkeleton" class="fill-height">
        <slot>
          <k-nodata-info>
            <template v-slot:icon>
              <i class="fas fa-search"></i>
            </template>
            <template v-slot:text>
              {{ nyelvesites['nincs_kereses_talalat_text'] }}
            </template>
          </k-nodata-info>
        </slot>
      </div>
    </template>
    <infinite-loading
      @infinite="GetHirek"
      :forceUseInfiniteWrapper="'#infinite-loading-container_' + ct"
      :identifier="'infinite-loading_' + ct"
    >
      <div slot="no-more">
        <span class="text--primary">***</span>
      </div>
      <div slot="no-results"></div>
      <div slot="error"></div>
      <div slot="spinner"></div>
    </infinite-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import uniqBy from 'lodash/uniqBy';
import { NotificationFunctions } from '../../functions/NotificationFunctions';
import InfiniteLoading from 'vue-infinite-loading';
import { timeout } from '../../utils/common';
import { AppStoreTypes } from '../../store/modules/app';
import { AppFunctions } from '../../functions/AppFunctions';

let ct = 0;
export default {
  name: 'k-hir-kereses-lista',
  data() {
    return {
      hirekLoading: true,
      showSkeleton: false,
      hirek: [],
      ct: ct++,
    };
  },
  async mounted() {
    await timeout(10);
    this.showSkeleton = true;
  },
  created() {},
  methods: {
    async GetHirek($state) {
      let result = null;
      try {
        result = await this.getHirek(this.utolsoHir);
        let hirekUpdated = [...this.hirek, ...result.Hirek];
        this.hirek = uniqBy(hirekUpdated, 'Id');
        this.$emit('update:osszesen', result.Osszesen);
      } catch (error) {
        NotificationFunctions.AjaxError({
          error,
        });
      }
      if ($state) {
        if (!result) {
          $state.loaded();
        } else if (result.Hirek.length > 0) {
          $state.loaded();
        } else {
          $state.complete();
        }
      }
      this.hirekLoading = false;
    },
  },
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
    }),
    utolsoHir() {
      return this.hirek[this.hirek.length - 1] ?? null;
    },
    listHeight() {
      let bottomNavHeight = this.$vuetify.application.bottom;
      //prettier-ignore
      return `height: calc(100vh - ${this.headerHeight + bottomNavHeight}px); overflow-y: scroll;`;
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {},
  props: {
    getHirek: {
      type: Function,
      required: true,
    },
    headerHeight: {
      type: Number,
      default: 70,
    },
    isElozmeny: {
      type: Boolean,
      default: false,
    },
    osszesen: {
      type: Number,
      required: true,
    },
  },
  components: {
    InfiniteLoading,
  },
};
</script>

<style>
mark {
  display: inline-block;
  background-color: #fff176 !important;
  border-color: #fff176 !important;
  padding: 4px !important;
  font-weight: 500 !important;
  color: #222 !important;
}
</style>
